const STORAGE_KEY = 'lip-referral-attribution'

function queryValue(value) {
  return Array.isArray(value) ? value[0] : value
}

function normalizeInviteCode(value) {
  return String(value || '')
    .trim()
    .replace(/\s+/g, '')
    .slice(0, 128)
}

function readStoredAttribution() {
  if (!import.meta.client) return null
  for (const store of [localStorage, sessionStorage]) {
    try {
      const raw = store.getItem(STORAGE_KEY)
      if (!raw) continue
      const value = JSON.parse(raw)
      const inviteCode = normalizeInviteCode(value?.invite_code || value?.code)
      if (!inviteCode) continue
      return {
        invite_code: inviteCode,
        ...(value?.ref ? { ref: String(value.ref).trim().slice(0, 320) } : {}),
      }
    } catch {
      /* try next store */
    }
  }
  return null
}

function writeStoredAttribution(attribution) {
  if (!import.meta.client) return false
  const raw = JSON.stringify(attribution)
  let ok = false
  for (const store of [localStorage, sessionStorage]) {
    try {
      store.setItem(STORAGE_KEY, raw)
      ok = true
    } catch {
      /* private mode / quota */
    }
  }
  return ok
}

/** Persist invite code from route/query (`code` or `invite_code`). */
export function captureReferralAttribution(query = {}) {
  if (!import.meta.client) return null
  const ref = String(queryValue(query.ref) || '').trim().slice(0, 320)
  const inviteCode = normalizeInviteCode(
    queryValue(query.invite_code) || queryValue(query.code),
  )
  if (!inviteCode) return null

  const attribution = {
    invite_code: inviteCode,
    ...(ref ? { ref } : {}),
  }
  return writeStoredAttribution(attribution) ? attribution : null
}

/** Prefer route query; fall back to `window.location.search` (survives some redirects). */
export function captureReferralAttributionFromLocation(query) {
  if (!import.meta.client) return null
  const fromQuery = captureReferralAttribution(query || {})
  if (fromQuery) return fromQuery
  try {
    const params = new URLSearchParams(window.location.search)
    return captureReferralAttribution({
      ref: params.get('ref') || '',
      code: params.get('code') || '',
      invite_code: params.get('invite_code') || '',
    })
  } catch {
    return null
  }
}

/** Payload for register/verify / Google login: `{ invite_code }` when present. */
export function getReferralPayload() {
  const stored = readStoredAttribution()
  return stored?.invite_code ? { invite_code: stored.invite_code } : {}
}

export function clearReferralAttribution() {
  if (!import.meta.client) return
  for (const store of [localStorage, sessionStorage]) {
    try {
      store.removeItem(STORAGE_KEY)
    } catch {}
  }
}
